export const environment = {
  production: true,
  baseUrl: 'https://crud.rapalmanac.com/',
  apiBaseUrl: 'https://api.rapalmanac.com',
  docUrl: 'https://api.rapalmanac.com/docs#',
  mapApiKey: 'e6b82eff-d5bd-4ae8-959f-f6b0c019ff5',
  ga4MeasurementId: 'G-RVNLQ01DJZ',
  stripe: {
    pricingTableId: 'prctbl_1RBp4eKVVLv7QuRNg7OLLODv',
    publishableKey: 'pk_live_51N8NgpKVVLv7QuRNKaE3v6Dv5wLyfxxcvsxSF2WhnAezZBDhMYBZuCejXrHs9CvDVQto48LdTwEPhfjNu9ZhiL2z00F6DEO9bq',
    portalLink: 'https://billing.stripe.com/p/login/eVq9AUdhu9ZX4eRbN0bEA00'
  }
};
